import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "helperText"];
import React from 'react';
import { bool, element, string, node } from 'prop-types';
import classNames from 'classnames';
import { FormControlLabel as MuiFormControlLabel } from '@material-ui/core';
import FormHelperText from '../form-helper-text/FormHelperText';
import useFormControlLabelStyles from './FormControlLabel.styles';
function FormControlLabel(props) {
  const {
      className,
      helperText
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const classes = useFormControlLabelStyles();
  const helperTextComponent = function () {
    const controlElementId = otherProps.control.props.id;
    return /*#__PURE__*/React.createElement(React.Fragment, null, otherProps.label, helperText && /*#__PURE__*/React.createElement(FormHelperText, {
      style: {
        opacity: 1
      },
      id: `${controlElementId}-helper-text`,
      "data-testid": "helperTextId"
    }, helperText));
  };
  return /*#__PURE__*/React.createElement(MuiFormControlLabel, Object.assign({}, otherProps, {
    className: classNames('pds-form-control-label', className),
    classes: classes,
    label: helperTextComponent(),
    htmlFor: otherProps?.control.props.id
  }));
}
FormControlLabel.propTypes = {
  /**
   * A CSS class to add to the root node of the component.
   */
  className: string,
  /**
   * A control element. For instance, it can be be a Radio or a Checkbox.
   */
  control: element.isRequired,
  /**
   * If true, the control will be disabled and the label will use disabled CSS styles.
   */
  disabled: bool,
  /**
   * The text to be used in an enclosing label element.
   */
  label: node.isRequired,
  /**
   * To add a helper text in a control element.
   */
  helperText: string
};
export default FormControlLabel;